<template>
    <div class="form-wrapper password-changed">
        <div class="success-alert">
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M59.999 106.746C85.8183 106.746 106.749 85.8154 106.749 59.9961C106.749 34.1768 85.8183 13.2461 59.999 13.2461C34.1797 13.2461 13.249 34.1768 13.249 59.9961C13.249 85.8154 34.1797 106.746 59.999 106.746ZM59.999 114.996C90.3747 114.996 114.999 90.3717 114.999 59.9961C114.999 29.6204 90.3747 4.99609 59.999 4.99609C29.6234 4.99609 4.99902 29.6204 4.99902 59.9961C4.99902 90.3717 29.6234 114.996 59.999 114.996Z" fill="#3B82F6"/>
                <path d="M53.6244 85.002C52.7102 85.002 51.8723 84.6561 51.1867 83.878L36.0274 66.6734C34.6562 65.1172 34.6562 62.6965 36.0274 61.1403C37.3986 59.5841 39.5316 59.5841 40.9028 61.1403L53.7005 75.5783L84.0953 41.1691C85.4665 39.6129 87.5994 39.6129 88.9706 41.1691C90.3418 42.7253 90.3418 45.146 88.9706 46.7022L56.1382 83.878C55.3764 84.6561 54.5385 85.002 53.6244 85.002Z" fill="#3B82F6"/>
            </svg>
        </div>
        <div 
            class="button button-accent button-authorize-next btn-hover btn-hover--green" 
            @click="$emit('change-type', 'login')"
        >
            <span>{{ $t('Go back to log in') }}</span>
        </div>
    </div>
</template>

<script>


export default {
    emits: ['activeStepUpdate', 'update-is-two-fa'],
    props: {
        authData: {
            type: Object,
        }
    },
}
</script>
